import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import { telemetry } from '../../services/telemetryService';
import { reloadOnceOnChunkLoadError } from '../../utils/chunkReload';
import { ErrorScreen } from './ErrorBoundary';

/**
 * React Router `errorElement`. Route render/lazy-load errors are intercepted
 * by the router itself, so the App-level <ErrorBoundary> around
 * <RouterProvider> never sees them — without this element the router renders
 * its own default error page (a dev stack screen locally, a blank page in
 * production). Baseline audit T-182/T-250: a crashing survey tab took the
 * whole route down with no branded recovery UI.
 */
export function RouteErrorElement() {
  const error = useRouteError();

  useEffect(() => {
    const normalized = error instanceof Error
      ? error
      : new Error(typeof error === 'string' ? error : JSON.stringify(error));
    // A stale-bundle chunk miss (deploy window) heals with one reload.
    if (reloadOnceOnChunkLoadError(normalized.message)) return;
    console.error('[RouteErrorElement] Route render error:', error);
    telemetry.trackError(normalized, { source: 'route-error-element' });
  }, [error]);

  return (
    <ErrorScreen message={error instanceof Error ? error.message : undefined} />
  );
}

export default RouteErrorElement;
